module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "economy-learning-compare"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "oekonomi.ebitda"
    }
  }), _vm._v("\n                    Kontoplan\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [(_vm.accountingYearsCheck && 'last_year_closed' in _vm.accountingYearsCheck && _vm.accountingYearsCheck.last_year_closed === false && !_vm.$auth.user().name.includes('Demo')) ? _c('div', {
    staticClass: "warning"
  }, [_c('b', [_vm._v("OBS! Seneste regnskabsår (" + _vm._s(_vm.accountingYearsCheck.year) + ") er ikke lukket i e-conomic.")]), _vm._v("\n                        Dette betyder, at tallene i din kontoplan summeres for både seneste regnskabsår samt det nuværende. Log in på e-conomic og luk det seneste regnskabsår for at se de korrekte tal. OBS! Du kan lukke og åbne et regnskabsår lige så ofte, det er nødvendigt.\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.sortedAccounts) ? _c('div', {
    staticClass: "ebitda-wrapper"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.sortedAccounts), function(accountCategory) {
    return _c('div', {
      key: accountCategory.uuid,
      staticClass: "line",
      class: {
        'bold': accountCategory.account_type === 'custom', 'selected': _vm.selectedAccountCategory && _vm.selectedAccountCategory.uuid === accountCategory.uuid
      },
      on: {
        "click": function($event) {
          return _vm.selectAccountCategory(accountCategory)
        }
      }
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v("\n                                " + _vm._s(accountCategory.name) + "\n                            ")]), _vm._v(" "), _c('div', {
      staticClass: "balance"
    }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(accountCategory.total_balance)) + "\n                            ")])])
  })], 2) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [(_vm.selectedAccountCategory) ? _c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n                    " + _vm._s(_vm.selectedAccountCategory.name) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [(_vm.selectedAccountCategory.accounts.length > 0) ? _c('div', {
    staticClass: "ebitda-wrapper child"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.selectedAccountCategory.accounts), function(account) {
    return (account.balance && account.balance !== '0.00' && !account.balance.startsWith('0.')) ? _c('div', {
      key: account.account_number,
      staticClass: "line"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v("\n                                " + _vm._s(account.account_number) + "\n                                -\n                                " + _vm._s(account.name) + "\n                            ")]), _vm._v(" "), _c('div', {
      staticClass: "balance"
    }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(account.balance)) + "\n                            ")])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n                                " + _vm._s(_vm.selectedAccountCategory.name) + "\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "balance"
  }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(_vm.selectedAccountCategory.total_balance)) + "\n                            ")])])], 2) : _c('div', [_vm._v("\n                        Denne konto har ingen underkonti\n                    ")])])]) : _c('div', [_vm._v("\n                Vælg en konto for at se dens underkonti her\n            ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line top"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("Konto")]), _vm._v(" "), _c('div', {
    staticClass: "balance"
  }, [_vm._v("Realiseret / bogført")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line top"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("Konto")]), _vm._v(" "), _c('div', {
    staticClass: "balance"
  }, [_vm._v("Bogført")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0466fc80", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0466fc80"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/economy/learning/ebitda.vue
// module id = 776
// module chunks = 0